export var GrabExpressDeliveryStatus;
(function (GrabExpressDeliveryStatus) {
    GrabExpressDeliveryStatus["Allocating"] = "ALLOCATING";
    GrabExpressDeliveryStatus["PickingUp"] = "PICKING_UP";
    GrabExpressDeliveryStatus["InDelivery"] = "IN_DELIVERY";
    GrabExpressDeliveryStatus["InReturn"] = "IN_RETURN";
    GrabExpressDeliveryStatus["Completed"] = "COMPLETED";
    GrabExpressDeliveryStatus["Canceled"] = "CANCELED";
    GrabExpressDeliveryStatus["Returned"] = "RETURNED";
    GrabExpressDeliveryStatus["Failed"] = "FAILED";
})(GrabExpressDeliveryStatus || (GrabExpressDeliveryStatus = {}));
